import React from "react";
import count1 from "../../assets/img/count1.png";
const CountCard = ({ teamMembers }) => {
  return (
    <div className="count-box">
      <div className="count-icon">
        <img src={count1} className="img-fluid" alt="" />
      </div>
      <div className="count-con">
        <h4>{teamMembers || 0}+</h4>
        <p>Team member</p>
      </div>
    </div>
  );
};

export default CountCard;
